// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "skin-80268.firebaseapp.com",
  "projectId": "skin-80268",
  "storageBucket": "skin-80268.appspot.com",
  "messagingSenderId": "474928306444",
  "appId": "1:474928306444:web:970896da6e7ccde53b1129",
  "measurementId": "G-GDGB3N61RN",
  "apiKey": "AIzaSyBeR5tZ-L4CVcldVwzLfLpkX2A9ScITvfw"
};
